import { Action } from '@ngrx/store';
import { ILocationConfigUnit } from '../../models/location-config.interface';

export const LOAD_INITIAL_STATE = '[Internal Comments]';
export const SET = '[Internal Comments] Set';

/**
 * Loads the initial state (but not value) of the special-instructions form-field.
 */
export class InternalCommentsLoadInitialState implements Action {
  readonly type = LOAD_INITIAL_STATE;

  constructor(public payload: ILocationConfigUnit) {}
}

export class InternalCommentsSetAction implements Action {
  readonly type = SET;

  constructor(public payload: string) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type InternalCommentsActionsType = InternalCommentsSetAction | InternalCommentsLoadInitialState;
